import { ActionTree } from "vuex";
import {
  RootState,
  StandRes,
  HomeResourcesRes,
  HomeState
} from "../../interface";
import { loadHomeDataAction } from "./action-types";
import { updateHomeResources } from "./mutation-types";
import { HttpClient } from "@/service/httpClient";
import { convertHomeRes } from "@/helper/homeHelpe";
import { isDevGetter } from "../user/getter-types";

export const actions: ActionTree<HomeState, RootState> = {
  [loadHomeDataAction]: ({ commit, state, rootGetters, rootState }) => {
    if (!state.homeResources.courseGroup) {
      let url = "/home";
      if (rootState.user?.invitationCode) {
        url += `?invitationCode=${rootState.user.invitationCode}`;
      }
      return HttpClient.get<StandRes<HomeResourcesRes>>(url).then(
        ({ data }) => {
          const isDev = rootGetters["user/" + isDevGetter];
          return commit(
            updateHomeResources,
            convertHomeRes(data.message, isDev)
          );
        }
      );
    }
  }
};
